import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/common/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import './i18n';

// Global error handlers
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    // Suppress WebSocket CONNECTING state errors from Appwrite realtime — handled by retry logic
    if (
      event.error instanceof DOMException ||
      (event.message && event.message.includes('CONNECTING'))
    ) {
      event.preventDefault();
      return;
    }
    if (event.message === 'Script error') {
      console.warn('[Script error] Often caused by cross-origin scripts.');
    }
  });
  window.addEventListener('unhandledrejection', (event) => {
    const msg = event.reason?.message || String(event.reason);
    // Suppress WebSocket CONNECTING errors — handled by retry logic in useRealtimeSubscription
    if (msg.includes('CONNECTING') || msg.includes('WebSocket')) {
      event.preventDefault();
      return;
    }
    console.error('[Unhandled rejection]', event.reason);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary fallbackMessage="An unexpected error occurred. Please refresh the page.">
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
